import { IonContent, IonIcon, IonModal } from '@ionic/react';
import React from 'react';
import { closeCircleSharp } from 'ionicons/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
// swiper bundle styles
import 'swiper/swiper-bundle.min.css';
// swiper core styles
import 'swiper/swiper.min.css';
import { Link, useHistory } from 'react-router-dom';
import { Folder } from '../../models/Folder';
import DAService from '../../services/DAService.service';
import TextHelper from '../../utils/TextHelper';
import './Modal.scss';
import LocalStorage from '../../utils/LocalStorage';

// eslint-disable-next-line
export default function ListModal(props: { showModal: any, setShowModal: any, parentId: any, toExpandId: any }) {
  const { showModal, setShowModal, toExpandId, parentId } = props;
  const topicIndex = (Number(LocalStorage.get('topicIndex')) - 1);
  const history = useHistory();
  let trueIndex = 0;
  let dropdownTopicIndex = 0;

  const updateTopicIndex = (selectedIndex: number) => () => {
    setShowModal(false);
    LocalStorage.set('topicIndex', selectedIndex);
  };

  const onItemClick = (parentData: any, clickedData: any, selectedIndex: number) => () => {
    setShowModal(false);

    switch (clickedData?.type) {
      case 'TOPIC':
        history.push(`/topics/${parentData.itemId}/${clickedData.itemId}`);
        LocalStorage.set('topicIndex', selectedIndex);
        break;
      case 'PROCESSGOAL':
      case 'GOAL':
        history.push(`/goals/${clickedData.itemId}`);
        break;
      case 'DECISION':
        history.push({
          pathname: `/goals/${parentData.itemId}`,
          state: {
            itemId: clickedData.itemId,
          },
        });
        break;
      default:
        break;
    }
  };

  return (
    <IonModal
      isOpen={showModal}
      onDidDismiss={() => setShowModal(false)}
      canDismiss
      style={{ paddingTop: '110px', borderRadius: '8px' }}
    >
      <div style={{ backgroundColor: '#501AA6' }}>
        <div style={{ textAlign: 'end' }}>
          <IonIcon
            style={{ fontSize: '24px', color: '#FFFFFF', cursor: 'pointer', padding: '8px 16px 0px 16px' }}
            src={closeCircleSharp}
            onClick={(() => {
              setShowModal(false);
            })}
          />

        </div>
        <div className="swiper-ctr">
          <div className="header-topic" style={{ padding: '8px 0px' }}>
            Browse By Topic
          </div>
          <Swiper
            className="swiper-topic"
            slidesPerView={4}
            observeParents
            observer
            initialSlide={topicIndex}
          >
            {
              DAService.getFolders().map((folder: Folder) => (
                folder.folderItems && folder.folderItems.map((topic) => {
                  trueIndex += 1;
                  return (
                    <SwiperSlide key={`slider-${topic.itemId}`}>
                      <Link
                        onClick={updateTopicIndex(trueIndex)}
                        to={`/topics/${folder.itemId}/${topic.itemId}`}
                        style={{ textDecoration: 'none' }}
                      >
                        <div className="topic-icon-container">
                          <div className="topic-icon-style">
                            <div className="topic-name">
                              {/* eslint-disable-next-line */}
                              {topic.name.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '')}
                            </div>
                          </div>
                          <div className="name-phase-container">
                            <div className="name-phase">
                              {topic.name}
                            </div>
                          </div>
                        </div>
                      </Link>
                    </SwiperSlide>
                  );
                })
              ))
            }
          </Swiper>
        </div>
      </div>

      <IonContent>
        <div>
          {DAService.getFolders().map((folder: Folder) => {
            dropdownTopicIndex += 1;
            return (
              <ul key={folder.itemId} style={{ paddingTop: '10px' }}>
                <li style={{ fontWeight: '600' }}>
                  {folder.name}
                </li>
                {folder?.folderItems?.map((topic) => (
                  <ul key={topic.itemId}>
                    <li style={(parentId === topic.itemId) ? { color: '#4F17A8', fontWeight: '600' } : {}}>
                      <button className="btn-topic" type="button" onClick={onItemClick(folder, topic, dropdownTopicIndex)}>
                        {topic.name}
                      </button>
                      {toExpandId && topic?.decisionPoints?.map((goal: any) => {
                        let elem: any;
                        if (topic.itemId === parentId) {
                          elem = (
                            <ul key={goal.itemId}>
                              <li style={(toExpandId === goal.itemId) ? { color: '#4F17A8', fontWeight: '600' } : { fontWeight: '300' }}>
                                <button className="btn-topic" type="button" onClick={onItemClick(topic, goal, dropdownTopicIndex)}>
                                  {TextHelper.stripHTML(goal.name)}
                                </button>
                              </li>
                            </ul>
                          );
                        }
                        return elem;
                      })}
                    </li>
                    {(topic?.folderItems)?.map((item: any) => (
                      <ul key={item.itemId}>
                        <li style={(parentId === item.itemId) ? { color: '#4F17A8', fontWeight: '600' } : {}}>
                          <button className="btn-topic" type="button" onClick={onItemClick(folder, item, dropdownTopicIndex)}>
                            {TextHelper.stripHTML(item.name)}
                          </button>
                          {toExpandId && item.decisionPoints?.map((child: any) => {
                            let elem: any;
                            if (item.itemId === parentId) {
                              elem = (
                                <ul key={child.itemId}>
                                  <li style={(toExpandId === child.itemId) ? { color: '#4F17A8', fontWeight: '600' } : { fontWeight: '300' }}>
                                    <button className="btn-topic" type="button" onClick={onItemClick(topic, child, dropdownTopicIndex)}>
                                      {TextHelper.stripHTML(child.name)}
                                    </button>
                                  </li>
                                </ul>
                              );
                            }
                            return elem;
                          })}
                        </li>
                      </ul>
                    ))}
                  </ul>
                ))}
              </ul>
            );
          })}
        </div>
      </IonContent>
    </IonModal>
  );
}
